import Dashboard from '../pages/Dashboard'
import SocialFeed from '../pages/dashboard/SocialFeed'
import Reports from '../pages/dashboard/Reports'
import Communities from '../pages/dashboard/Communities'
import PageNotFound from '../pages/errors/PageNotFound'
import AdminProfile from '../pages/users/AdminProfile'
import AdminBilling from '../pages/users/AdminBilling'
import Subscriptions from '../pages/users/Subscriptions/Subscriptions'
import Notifications from '../pages/notifications/Notifications'
import AddCampaign from '../pages/campaigns/AddCampaign'
import CampaignList from '../pages/campaigns/CampaignList'
import EditCampaign from '../pages/campaigns/EditCampaign'
import AppLayout from '../layouts/AppLayout'
import { DocumentsRoutes } from './documents-routes'
import { PlatformsRoutes } from './platforms-routes'
import { LandingPageRoutes } from './landing-page-routes'
import { CallbacksRoutes } from './callbacks-routes'
import ResetPassword from '../pages/ResetPassword'
import { Navigate } from 'react-router-dom'

import CampaignRoutes from './campaigns'
import { CampaignInsights } from './campaign-insights'
import { CampaignCreatives } from './campaign-creatives'

import { MediaBuyLayout } from '../layouts/mediaBuyLayout'

export const MainRoutes = [
    {
        path: '/',
        element: <AppLayout />,
        children: [
            {
                path: '/',
                element: <Navigate to="/dashboard/overview" replace />,
            },
            {
                path: 'dashboard',
                children: [
                    { index: true, element: <Navigate to="overview" replace /> },
                    { path: 'overview', element: <Dashboard /> },
                    { path: 'social-feed', element: <SocialFeed /> },
                    { path: 'reports', element: <Reports /> },
                    { path: 'communities', element: <Communities /> },
                ],
            },
            {
                path: 'profile',
                element: <AdminProfile />,
            },
            {
                path: 'billing',
                element: <AdminBilling />,
            },
            {
                path: 'subscriptions',
                element: <Subscriptions />,
            },
            {
                path: 'notifications',
                element: <Notifications />,
            },
            {
                path: 'campaigns',
                element: <CampaignList />,
            },
            {
                path: 'campaigns/new',
                element: <AddCampaign />,
            },
            {
                path: 'campaigns/edit/:id',
                element: <EditCampaign />,
            },
            {
                path: 'campaigns/:id/dashboard',
                element: <Dashboard />,
            },
            {
                path: 'campaigns/:id/social-feed',
                element: <SocialFeed />,
            },
            {
                path: 'campaigns/:id/reports',
                element: <Reports />,
            },
            {
                path: 'campaigns/:id/communities',
                element: <Communities />,
            },
            {
                path: 'reset-password',
                element: <ResetPassword />,
            },
            ...DocumentsRoutes,
            ...PlatformsRoutes,
            ...LandingPageRoutes,
        ],
    },
    {
        path: 'campaigns/media-buying',
        element: <MediaBuyLayout />,
        children: [
            ...CampaignRoutes,
            ...CampaignInsights,
            ...CampaignCreatives
        ],
    },
    ...CallbacksRoutes,
    {
        path: '*',
        element: <PageNotFound />,
    },
]
